import { GET_KEY_TYPES_LOADING, GET_KEY_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getKeyTypesSuccess = payload => {
    return ({
        type: GET_KEY_TYPES_SUCCESS,
        payload
    })
}

export const getKeyTypesAsync = payload => dispatch => {
    return client.service('key-types').find()
		.then((response) => {
            dispatch(getKeyTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}